import { render } from "./ThumbRounded.vue?vue&type=template&id=40202626"
import script from "./ThumbRounded.vue?vue&type=script&lang=js"
export * from "./ThumbRounded.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__